export default __webpack_public_path__ + "images/7W.4e7fb6a.png";